import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography/Typography";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import * as ReactGA from "react-ga";
import Button from "@material-ui/core/Button/Button";
import clsx from 'clsx';
import useDetectPrint from "use-detect-print";

const useStyles = makeStyles({
    root: {
        marginTop: 10
    },
    table: {
        minWidth: '100%',
    },
    th: {
        paddingLeft: 0,
        width: '15%'
    },
    thMobile: {
        paddingLeft: 0,
        width: '35%'
    },
    td: {
        paddingLeft: 0,
        width: '25%'
    },
    tdMobile: {
        paddingLeft: 0,
        width: '65%'
    },
    detail: {
        marginTop: 10
    },
    contactIcon: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 0,
        borderBottom: '1px dashed #ccc',
        paddingBottom: 5
    },
    btn: {
        marginTop: 5
    },
    last: {
        borderBottom: 0
    }
});

export default function Details(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState();

    const item = props.item;
    const allItems = item.details;

    const isMobile = props.isMobile;

    let maxItems = open ? allItems.length : (isMobile ? 14 : 14);

    const isPrinting = useDetectPrint();

    if (isPrinting) {
        maxItems = allItems.length;
    }


    const half = allItems.length > maxItems ? maxItems / 2 : Math.ceil(allItems.length/2);

    const remainCount = Math.max(0, allItems.length - maxItems);

    const parts = isMobile ? [
        item.details.slice(0, maxItems)
    ] : [
        item.details.slice(0, half),
        item.details.slice(half + Math.ceil(remainCount/2))
    ];

    const hasExpand = allItems.length > maxItems;

    const handleOpen = () => {
        if (!open) {
            setOpen(true);
            ReactGA.event({
                category: 'User',
                action: 'details_expand'
            });
        }
    };

    const handleClose = () => {
        if (open) {
            setOpen(false);
        }
    };

    const th = isMobile ? classes.thMobile : classes.th;
    const td = isMobile ? classes.tdMobile : classes.td;

    return (
        <div className={classes.root}>
            <div className={classes.contactIcon}>
                <Typography>Details</Typography>
                <ArrowDropDownIcon style={{
                    paddingLeft: '5',
                }}/>
            </div>
            <Table className={classes.table} size="small" aria-label="details">
                <TableBody>
                    {parts[0].map((detail,index) => (
                        <>
                            <TableRow key={detail.name}>
                                <TableCell component="th" scope="row" className={open && index === parts[0].length - 1 ? clsx(th, classes.last) : th}>
                                    <b>{detail.name}</b>
                                </TableCell>
                                <TableCell align="left" className={open && index === parts[0].length - 1 ? clsx(td, classes.last) : td}>{detail.value}</TableCell>
                                {parts[1] && parts[1][index] ?
                                    <>
                                        <TableCell component="th" scope="row" className={open && index === parts[1].length - 1 && parts[1].length === half ? clsx(th, classes.last) : th}>
                                            <b>{parts[1][index].name}</b>
                                        </TableCell>
                                        <TableCell align="left" className={open && index === parts[1].length - 1 && parts[1].length === half ? clsx(td, classes.last) : td}>{parts[1][index].value}</TableCell>
                                    </> : ''}
                            </TableRow>
                        </>
                    ))}
                    {hasExpand ?

                        <TableRow key="...">
                            <TableCell component="th" scope="row" className={clsx(th, classes.last)}>
                                ...
                            </TableCell>
                            <TableCell align="left" className={clsx(td, classes.last)}></TableCell>
                            {parts[1] ?
                                <>
                                    <TableCell component="th" scope="row" className={clsx(th, classes.last)}>
                                        ...
                                    </TableCell>
                                    <TableCell align="left" className={clsx(td, classes.last)}></TableCell>
                                </> : ''}
                        </TableRow>
                         : ''}
                </TableBody>
            </Table>
            {hasExpand ? <Button variant="outlined" size="small" onClick={handleOpen} className={classes.btn}>All Details</Button> : ''}
            {open ? <Button variant="outlined" size="small" onClick={handleClose} className={classes.btn}>Less Details</Button> : ''}
        </div>
    );
}